import type { RouteLocationRaw } from '#vue-router';
import { useState } from '#app/composables/state';

export type BreadCrumb = {
  text: string;
  to?: RouteLocationRaw;
  external?: boolean;
};

export function useBreadcrumbs() {
  const breadcrumbsState = useState<BreadCrumb[]>('breadcrumbs', () => []);

  function setBreadcrumbs(newValue: BreadCrumb[]) {
    breadcrumbsState.value = newValue;
  }

  function clearBreadcrumbs() {
    breadcrumbsState.value = [];
  }

  return {
    breadcrumbsState,
    setBreadcrumbs,
    clearBreadcrumbs,
  };
}
